import * as z from 'zod/mini';
import { defineFormInput } from './defineFormInput.js';
/**
 * Schema for scale input configuration.
 */
export const ScaleInput = defineFormInput({
    type: 'SCALE',
    input: {
        question: z.string(),
        help: z.optional(z.string()),
        /** Minimum value of the scale */
        minValue: z.number(),
        /** Label for the lowest value on the scale */
        minLabel: z.optional(z.string()),
        /** Maximum value of the scale */
        maxValue: z.number(),
        /** Label for the highest value on the scale */
        maxLabel: z.optional(z.string()),
        /** Label for the middle value on the scale */
        middleLabel: z.optional(z.string()),
        /** Step of the scale */
        step: z.number(),
    },
    value: {
        value: z.number(),
    },
});
//# sourceMappingURL=ScaleInput.js.map